export const getMonths = (startDate?: Date, endDate?: Date, includeText = true) => {
    if (!startDate || !endDate) {
        return '';
    }
    try {
        const startDate1 = new Date(startDate);
        const endDate1 = new Date(endDate);
        const mnthCount = endDate1.getMonth() - startDate1.getMonth() + 12 * (endDate1.getFullYear() - startDate1.getFullYear());
        if (mnthCount === 1) {
            return mnthCount + (includeText ? ' month' : '');
        } else {
            return mnthCount + (includeText ? ' months' : '');
        }
    } catch {
        return '';
    }
};
